import * as React from 'react';
import { FlatDataPoint, ParentId } from '@web-config-app/core';
import {
  DataPointCategoryItem,
  PassIdFunction,
} from './data-point-category-item.component';
import { DataPointCopyItem } from './data-point-copy-item.component';
import { DataPointRadioItem } from './data-point-radio-item.component';

interface DataPointItemProps {
  dataPoint: FlatDataPoint;
  index: number;
  mode: 'radio' | 'copy';
  selectedDataPoint?: ParentId;
  onNavigate: PassIdFunction;
  onSelectItem: PassIdFunction;
}

export const DataPointItem: React.FC<DataPointItemProps> = ({
  dataPoint,
  index,
  mode,
  selectedDataPoint,
  onNavigate,
  onSelectItem,
}) => {
  const { id, isCategory, label, parentId } = dataPoint;
  const itemId = id || `item_${index}`;

  if (isCategory) {
    return (
      <DataPointCategoryItem id={id} label={label} onNavigate={onNavigate} />
    );
  }

  if (mode === 'copy') {
    return <DataPointCopyItem id={id} label={label} />;
  }

  return (
    <DataPointRadioItem
      id={id}
      label={label}
      parentId={parentId}
      selectedDataPoint={selectedDataPoint}
      onSelectItem={onSelectItem}
      itemId={itemId}
    />
  );
};
